import { CalEventFieldType } from '../constants/cal-event-field-type.js';
export const FIELD_TYPE_VALUE_KIND = {
    [CalEventFieldType.TEXT]: 'string',
    [CalEventFieldType.NUMBER]: 'number',
    [CalEventFieldType.DATE]: 'date',
    [CalEventFieldType.SELECT]: 'string',
    [CalEventFieldType.ENTITY_REF]: 'none',
    [CalEventFieldType.SYSTEM_TIMESTAMP]: 'none',
    [CalEventFieldType.PER_PRODUCT_NUMBER]: 'none',
};
//# sourceMappingURL=field-type-value-kind.js.map